;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabs = require("../mixins/tabs");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [{ name: "tires", title: "Подобрать шины" }, { name: "disks", title: "Подобрать диски" }];
      }
    }
  },
  mixins: [(0, _tabs2.default)("tabs")]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ss-tabs"},[_c('div',{staticClass:"ss-tabs__header"},[_c('div',{staticClass:"ss-tabs__buttons"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.name,staticClass:"ss-tabs__button",class:{ 'is-active': tab.name === _vm.current },attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle(tab.name)}}},[_vm._v("\n        "+_vm._s(tab.title)+"\n      ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"ss-tabs__body"},[_c('ul',{staticClass:"ss-tabs__list"},_vm._l((_vm.tabs),function(tab){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(tab.name === _vm.current),expression:"tab.name === current"}],key:tab.name,staticClass:"ss-tabs__item"},[_vm._t(tab.name)],2)}),0)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3322a32c", __vue__options__)
  } else {
    hotAPI.reload("data-v-3322a32c", __vue__options__)
  }
})()}